module.exports = __webpack_public_path__ + "static/media/04.b709e815.mp3";